import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = ["fill"];
import { computed } from 'vue';
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ClassSVG',
    setup(__props) {
        const store = useStore();
        const consumerColors = computed(() => store.getters.getConsumerColors);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("path", {
                    d: "M22.2507 17.3316L19.9489 10.7516L18.3012 11.3381C17.1762 11.7383 15.9397 11.1511 15.5392 10.0263C15.1389 8.90155 15.7259 7.66505 16.8512 7.2643L18.5209 6.67005L17.0239 2.39105C16.8002 1.75105 16.1002 1.41405 15.4604 1.6378L10.8922 3.2358L10.2519 1.43755C9.85167 0.312802 8.61517 -0.274698 7.49017 0.125802C6.36542 0.526052 5.77792 1.76255 6.17817 2.88755L6.81042 4.6638L2.52792 6.16205C1.88792 6.3858 1.55092 7.0858 1.77467 7.7258L3.42317 12.4381L1.43767 13.1451C0.312923 13.5453 -0.274576 14.7818 0.125674 15.9068C0.526174 17.0316 1.76267 17.6191 2.88767 17.2188L4.85117 16.5198L7.00142 22.6663C7.22542 23.3061 7.92517 23.6436 8.56517 23.4196L13.1839 21.8038L12.4974 19.8751C12.0972 18.7503 12.6842 17.5138 13.8094 17.1133C14.9342 16.7131 16.1707 17.3001 16.5712 18.4253L17.2657 20.3761L21.4979 18.8953C22.1372 18.6713 22.4744 17.9711 22.2507 17.3316Z",
                    fill: consumerColors.value?.primary_color
                }, null, 8, _hoisted_2)
            ]));
        };
    }
});
